<template>
	<div>
		<label class="addon-config-label text-bold" v-if="showTitle">Custom Meta Tags</label>
		<div
			class="card mb-2"
			v-for="(meta, index) in value"
			:key="index">
			<div class="card-body p-1">
				<div class="d-flex justify-content-between align-items-center">
					<div class="d-flex justify-content-between w-100">
						<div class="form-group col-sm-4 pr-0 mt-2">
							<label class="mb-1"><small>Name</small></label>
							<input
								type="text"
								class="form-control"
								placeholder="name"
								:value="meta.name"
								@change="onChange($event, index, 'name')"
							>
						</div>
						<div class="form-group col-sm-8 mt-2 pr-1">
							<label class="mb-1"><small>Content</small></label>
							<input
								type="text"
								class="form-control"
								placeholder="content"
								:value="meta.content"
								@change="onChange($event, index, 'content')"
							>
						</div>
					</div>
					<div class="mt-3 pt-1 pr-3">
						<button
							class="btn btn-sm btn-outline-danger"
							@click="remove(index)"
							v-tooltip="'Remove Tag'">
							<i class="material-icons m-0">delete</i>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div
			class="border border-dashed border-gray rounded text-center p-3"
			v-if="value.length === 0">
			No Meta Found
		</div>
		<button class="btn btn-sm btn-outline-primary mt-2 px-4" @click="add">Add Meta</button>
	</div>
</template>

<script>
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'MetaTags',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		showTitle: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			metas: [],
		};
	},
	methods: {
		add() {
			const newMeta = {
				name: '',
				content: '',
			};
			const metas = duplicateVar(this.value);
			metas.push(newMeta);
			this.$emit('input', metas);
		},
		remove(index) {
			const metas = duplicateVar(this.value);
			metas.splice(index, 1);
			this.$emit('input', metas);
		},
		onChange(e, index, key) {
			let value = e.target.value;
			if (value) {
				value = value.trim();
			}
			const metas = duplicateVar(this.value);
			metas[index][key] = value;
			this.$emit('input', metas);
		},
	},
};
</script>
